import { render, staticRenderFns } from "./Myorderywc.vue?vue&type=template&id=1fae3965&scoped=true&"
import script from "./Myorderywc.vue?vue&type=script&lang=js&"
export * from "./Myorderywc.vue?vue&type=script&lang=js&"
import style0 from "./Myorderywc.vue?vue&type=style&index=0&id=1fae3965&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fae3965",
  null
  
)

export default component.exports